module.exports = __webpack_public_path__ + "img/doctor.231ce408.jpeg";